module.exports = __webpack_public_path__ + "img/表1-8用圆弧光滑连接两条圆弧的画法.05ab40d0.png";